module.exports = __webpack_public_path__ + "static/media/foto4.69c17354.jpg";